import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import styled from 'styled-components'

import { Hint, StyledLabel, StyledInput } from './formStyles'

const buildOptions = options =>
  Object.keys(options).map(key => (
    <option key={key} value={key}>
      {options[key]}
    </option>
  ))

const StyledSelect = styled.select`
  /* Ensure our select style has more specificity so ecomm styles don't overide */
  && {
    border-radius: 2px;
    border: solid 1px lightgray;
    box-sizing: border-box;
    font-size: 14px;
    margin-top: 5px;
    line-height: 48px;
    padding: 0 10px;
    width: 100%;
    height: 48px;
    .input-error & {
      border-color: red;
    }
  }
`

export const Select = props => {
  const {
    autoFocus,
    errors,
    label,
    label: {
      props: { id, className: labelClassNames = '' },
    },
    name,
    onBlur,
    onChange,
    touched,
    type,
    value,
    options = {},
    hint = '',
    ...rest
  } = props

  return (
    <StyledLabel
      htmlFor={id}
      className={`${labelClassNames} ${
        touched && errors && errors.length > 0 ? 'input-error' : ''
      }`}
    >
      {label}
      <StyledSelect
        component="select"
        type={type}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        id={id}
        value={value}
        autofocus={autoFocus}
        {...rest}
      >
        {buildOptions(options)}
      </StyledSelect>
      {!!hint && <Hint>{hint}</Hint>}
      {touched && errors && <div className="input-error-message">{errors}</div>}
    </StyledLabel>
  )
}
Select.propTypes = {
  label: PropTypes.shape({
    props: PropTypes.shape({
      id: PropTypes.string.isRequired,
      className: PropTypes.string,
    }),
  }),
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.any,
  touched: PropTypes.bool,
  autoFocus: PropTypes.bool,
  errors: PropTypes.any,
  id: PropTypes.string,
  hint: PropTypes.object,
  rest: PropTypes.any,
  options: PropTypes.object,
}

export default Select



// WEBPACK FOOTER //
// ./src/components/FormElements/Select.js